'use strict';

module.exports = require("./cjs/react-use-timeout.js");
